<template>
  <div class="app-container cheliang-page">
    <div class="search-div common-section-bg">
      <div class="shaixuan-item">
        <el-select v-model="reportType" clearable placeholder="报表类型" size="mini">
          <el-option label="有效期异常明细" value="有效期异常明细" />
          <el-option label="一位多车明细" value="一位多车明细" />
          <el-option label="特殊车辆明细" value="特殊车辆明细" />
        </el-select>
      </div>
      <div class="shaixuan-item">
        <el-button type="primary" size="mini" class="btn-primary-blue" icon="el-icon-search" @click="filterList">查询</el-button>
        <el-button size="mini" icon="el-icon-download" @click="handleExport">导出 Excel</el-button>
      </div>
    </div>
    <div class="common-section-bg common-section-body table-wrap">
      <el-table :data="displayList" size="mini" style="width: 100%; min-height: 300px">
        <el-table-column prop="report_name" label="报表名称" width="130" show-overflow-tooltip />
        <el-table-column prop="city" label="城市" width="70" />
        <el-table-column prop="project" label="项目" width="100" show-overflow-tooltip />
        <el-table-column prop="plate" label="车牌号" width="110" />
        <el-table-column prop="owner" label="业主" width="80" show-overflow-tooltip />
        <el-table-column prop="abnormal_type" label="异常类型" width="110" />
        <el-table-column prop="generate_time" label="生成时间" min-width="150" show-overflow-tooltip />
      </el-table>
      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="listQuery.page"
        :limit.sync="listQuery.size"
        @pagination="refreshPage"
      />
    </div>
  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import { reportList } from '../mockData'

export default {
  name: 'DataReport',
  components: { Pagination },
  data() {
    return {
      reportList,
      displayList: [],
      reportType: '',
      listQuery: { page: 1, size: 10 },
      total: 0
    }
  },
  created() {
    this.refreshPage()
  },
  methods: {
    getFilteredRows() {
      return this.reportType
        ? this.reportList.filter(item => item.report_name === this.reportType)
        : this.reportList
    },
    refreshPage() {
      const filtered = this.getFilteredRows()
      this.total = filtered.length
      const start = (this.listQuery.page - 1) * this.listQuery.size
      this.displayList = filtered.slice(start, start + this.listQuery.size)
    },
    filterList() {
      this.listQuery.page = 1
      this.refreshPage()
    },
    handleExport() { this.$message.success('导出 Excel（演示）') }
  }
}
</script>

<style lang="scss" scoped>
@import '../styles/page.scss';
</style>
